import React from "react";
import "./surrounding.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Surroundingimages from "./surrounding.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faGraduationCap,
  faHouse,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";

const lokasi = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div id="surroundingarea" className="surroundingarea">
      <div className="container-surrounding">
        <div id="surrounding" className="judul-surrounding">
          <h1>Surrounding Area</h1>
        </div>
        <div className="container-card">
          <div className="kartu">
            <Slider {...settings}>
              {Surroundingimages.map((image, index) => (
                <div>
                  <img
                    className="kartugambar1"
                    key={index}
                    src={image}
                    alt="athena"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <div className="Lokasi12">
        <div className="benefit-container12">
          <div className="benefit-point1">
            <div className="benefit-title1">
              <FontAwesomeIcon icon={faGraduationCap} /> &nbsp;Education
            </div>
            <div className="benefit">
              <div className="point">
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Al-Irsyad Satya Islamic School
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;BPK Penabur School
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Universitas Kristen Maranatha
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Cahaya Bangsa Classical School
              </div>
            </div>
          </div>
          <div className="benefit-point1">
            <div className="benefit-title1">
              <FontAwesomeIcon icon={faHouse} /> &nbsp;Health Care
            </div>
            <div className="benefit1">
              <div className="point">
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Cahya Kawaluyan Hospital
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;RSIA Parahyangan
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Zen Reflexiology
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Rumah Sakit TK II Dustira
              </div>
            </div>
          </div>
          <div className="benefit-point1">
            <div className="benefit-title1">
              <FontAwesomeIcon icon={faBuilding} /> &nbsp;Entertainment
            </div>
            <div className="benefit1">
              <div className="point">
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Parahyangan Golf
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Lake View
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Wahoo Waterland
                <br />
                <FontAwesomeIcon icon={faMapPin} />
                &nbsp;&nbsp;Kota Baru Food Market
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default lokasi;
